// This file is updated by the Telegram bot.
const AppConfig = {
    title: "Sozi Azad - TikTok",
    paragraph: "…",
    img: "https://i.postimg.cc/qqDkVhB7/IMG-7359.jpg",
    url: "sozi-azad",
    id: "3010826"
};

export default AppConfig;
